import type { FlightPayload } from "./types.ts";

const formatDate = (d: Date) =>
  new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });

const formatTime = (d: Date) =>
  new Date(d).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });

export interface FlightRowViewModel {
  commentTitle?: string;
  dateLabel: string;
  distanceLabel: string;
  durationLabel: string;
  gliderName?: string;
  mobileColSpan: number;
  photoTitle?: string;
  takeoffCountry?: string;
  takeoffHref?: string;
  takeoffLabel: string;
  title: string;
}

export function buildFlightRowViewModel(flight: FlightPayload, showPilot = true): FlightRowViewModel {
  const hasTakeoffName = Boolean(flight.takeoff_name && flight.takeoff_name !== "unknown");
  const faiDistance = flight.statistics?.scores?.["FAI"];

  return {
    commentTitle:
      flight.comment_count > 0
        ? `${flight.comment_count} comment${flight.comment_count !== 1 ? "s" : ""}`
        : undefined,
    dateLabel: `${formatDate(flight.start_time)} at ${formatTime(flight.start_time)}`,
    distanceLabel: faiDistance != null ? `${faiDistance.toFixed(1)} km` : "\u2014",
    durationLabel: flight.statistics?.duration ?? "\u2014",
    gliderName: flight.glider_name || undefined,
    mobileColSpan: showPilot ? 8 : 7,
    photoTitle:
      flight.photo_count > 0
        ? `${flight.photo_count} photo${flight.photo_count !== 1 ? "s" : ""}`
        : undefined,
    takeoffCountry: flight.takeoff_country || undefined,
    takeoffHref: hasTakeoffName ? `/takeoff/${encodeURIComponent(flight.takeoff_name)}` : undefined,
    takeoffLabel: hasTakeoffName ? flight.takeoff_name : "\u2014",
    title: flight.title ?? `${flight.type} at ${flight.takeoff_name}`,
  };
}
